import Week from '@/app/components/search/components/DatePickers/DatePicker/Months/Week';
import type { DatePickersProps } from '@/app/components/search/components/DatePickers';
import { DatePickers } from '@/app/components/search/components/DatePickers';
import React from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import type { Dates } from '@/app/components/search/utils';
import { CustomCalendarBodyContainer } from '@/app/common/components/Modals/CustomCalendar/CustomCalendarBody/styled.ts';
import { CustomDatePickerHeader } from '../CustomDatePickerHeader';

const CustomCalendarBody = ({
  customDates,
  returnDateWasPreselected,
  datePickersProps,
}: {
  customDates: Dates | undefined;
  returnDateWasPreselected?: boolean;
  datePickersProps: DatePickersProps;
}) => {
  const { isMobile } = useCommonClient();
  return isMobile ? (
    <CustomCalendarBodyContainer>
      <CustomDatePickerHeader dates={customDates} returnDateWasPreselected={returnDateWasPreselected} />
      <Week style={{ position: 'static', border: 'none' }} />
      <DatePickers {...datePickersProps} />
    </CustomCalendarBodyContainer>
  ) : (
    <DatePickers {...datePickersProps} />
  );
};

export default CustomCalendarBody;
